import { render, staticRenderFns } from "./SettingsPage.vue?vue&type=template&id=62d3968f&scoped=true"
import script from "./SettingsPage.vue?vue&type=script&lang=ts"
export * from "./SettingsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d3968f",
  null
  
)

export default component.exports